var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('p',{staticClass:"onboarding__wrapper"},[_vm._v(_vm._s(_vm.$t('onboarding.none.description')))]),_c('div',{staticClass:"button-row"},[_c('b-button',{attrs:{"type":"is-primary","rounded":""},on:{"click":function($event){return _vm.disableMFA()}}},[_vm._v(_vm._s(_vm.$t('onboarding.none.finish')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }